import React, { useEffect, useState } from 'react'

import { DateTime } from 'luxon'

import Message from '@Pure/Message'

import request from '@function/ajax/request'

export default function EcNotRenewedWarning ({ ...props })
{
	const [EC_status, setECStatus] = useState();

	useEffect(function ()
	{
		if (isHidden()) return null;

		(async function ()
		{
			try
			{
				var { status } = await request('/EC-renewal/is-renewed')
				.config({ keyword: 'ressource' })
				.post({ });
			}
			catch (update)
			{
				return;
			}

			setECStatus(status);
		})();
	},
	[]);

	if (isHidden()) return null;

	if (EC_status !== 'discontinued') return null;

	return (
		<Message color="red" icon="info"
			className="u-margin-bottom-0 u-margin-top-0">
			En l’absence de réadhésion de votre structure, l’accès à nos services est suspendu. Les commandes en cours sont récupérables jusqu’au
			{ ' ' }
			{
				DateTime.now()
				.startOf('year')
				.endOf('month')
				.toFormat('dd/MM/yyyy')
			}
			.
		</Message>
	);
}

function isHidden ()
{
	const NOW = DateTime.now();

	const from = NOW.startOf('year'), to = NOW.startOf('year').endOf('month');

	return NOW < from || NOW > to;
}